import { useContext } from 'react'
import { UpdateStatusContext, type UpdateStatusContextValue } from '../contexts/UpdateStatusProvider'

export type { UpdateStatus, UpdateState } from '../contexts/UpdateStatusProvider'

export function useUpdateStatus(): UpdateStatusContextValue {
  const ctx = useContext(UpdateStatusContext)
  if (ctx === undefined) {
    throw new Error('useUpdateStatus must be used within an UpdateStatusProvider')
  }
  return ctx
}

/**
 * Trigger a manual update check without subscribing to the context.
 * Use this in components that only need to start a check and don't
 * render any update UI (e.g. UserAvatar dropdown menu).
 */
export function checkForUpdates() {
  window.api?.invoke('check-for-updates')
}
